module.exports = __webpack_public_path__ + "public/files/img/lessons.1d55b001.png";